(function ($) {

    /*------------------------------------*\
        DEVHUB COPY BUTTON
        Copies the text content of the nearest .devhub-code-block__pre
        to the clipboard. Button: .js-copy-btn.
        Adds .is-copied class briefly after success.
    \*------------------------------------*/

    $.fn.devhubCopyBtn = function () {

        var init = function () {

            $(document).on('click', '.js-copy-btn', function () {

                var $btn  = $(this);
                var $pre  = $btn.closest('.devhub-code-block').find('.devhub-code-block__pre');
                var text  = $pre.text();

                if (!text || !navigator.clipboard) {
                    return;
                }

                navigator.clipboard.writeText(text).then(function () {

                    var original = $btn.text();

                    $btn.text('Copied!').addClass('is-copied');

                    setTimeout(function () {

                        $btn.text(original).removeClass('is-copied');

                    }, 2000);

                });

            });

        };

        init();

        return this;

    };

}(jQuery));
